import { Redirect } from 'react-router-dom';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { localizeRoutes } from '../utils/routeUtils';

import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import DownloadEbonBillPage from '../components/pages/ebon/bill/DownloadEbonBillPage';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: Redirect,
        to: PATH.EBON_DOWNLOAD_BILL_PATH
    },
    {
        path: `${PATH.EBON_DOWNLOAD_BILL_PATH}`,
        component: DownloadEbonBillPage
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: NotFoundPage
    }
];

export const allRoutes = [...routes];



// WEBPACK FOOTER //
// ./src/routes/index.js